export default __webpack_public_path__ + "static/media/DreamJobs1_20.76186d4a.png";